<template>
  <div id="app">
    <el-header class="homeHeader" height="213px" direction="vertical" style="padding: 0px" v-if="$route.meta.keepAlive">
      <div class="headerTop">
        <img src="./assets/img/newHome/logo2.png" style="width:350px" />
        <img src="./assets/img/newHome/tagline.png"  />
        <div class="searchContent" >

          <el-input v-model="input" placeholder="请输入内容" style="padding: 10px ;"></el-input>
          <div class="searchButton" @click="searchData()">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <!-- <div>
          <img src="./assets/img/newHome/slogan.png" style="width:400px" />
          <div style="font-weight: 700;color: #000000;">{{year}}年{{month}}月{{day}}日 | {{currentWeekDay}} |农历.{{ lunarYear }}年 | {{ lunarMonth }}月{{ lunarDay }}</div>
        </div> -->
      </div>
      <div  class="menuBox">
        <div style="width: 100%;">

       
        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" router style="display: flex;
  list-style: none; /* 移除默认列表符号 */
  padding: 0;
  margin: 0;
  width: 100%;">
            <el-menu-item index="/" class="full-width-item">
              <!-- <router-link to="/" >首页</router-link> -->
              首页
            </el-menu-item>
            <el-menu-item index="/list/1/协会动态" class="full-width-item">
              协会动态
              <!-- <router-link to="/list/1/协会动态" style="text-decoration: none;">协会动态</router-link> -->
            </el-menu-item>
            <el-menu-item index="/list/2/通知公告" class="full-width-item" >
              通知公告
              <!-- <router-link to="/list/2/通知公告" style="text-decoration: none;">通知公告</router-link> -->
            </el-menu-item>
            <el-menu-item index="/list/3/行业资讯" class="full-width-item">
              <el-dropdown placement="bottom">
                <span class="el-dropdown-link">
                  <span @click="onPage2('/list/3/行业资讯')">行业资讯</span>
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menuTwo">
                  <el-dropdown-item @click.native="onPage2('/list/3/国内资讯?infoType=1')">国内资讯</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/list/3/省内资讯?infoType=2')">省内资讯</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
            <el-menu-item index="/list/4/政策法规" class="full-width-item">
              <el-dropdown placement ="bottom"   >
                <span class="el-dropdown-link">
                  <span @click="onPage2('/list/4/政策法规')">政策法规</span> 
                  <!-- <img src="./assets/img/newHome/downIcon.png" style="margin-left: 5px;" /> -->
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                  <el-dropdown-item @click.native="onPage2('/list/4/国家规范性文件?menuType=1')">国家规范性文件</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/list/4/地方规范性文件?menuType=2')">地方规范性文件</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
            <el-menu-item index="/list/7/党建园地" class="full-width-item">
              党建园地
              <!-- <router-link to="/list/7/党建园地" style="text-decoration: none;">党建园地</router-link> -->
            </el-menu-item>
            <el-menu-item index="/list/5/诚信自律" class="full-width-item" >
              诚信自律
              <!-- <router-link to="/list/5/诚信自律" style="text-decoration: none;">诚信自律</router-link> -->
            </el-menu-item>
            <el-menu-item index="/member" class="full-width-item">
              <el-dropdown placement="bottom">
                <span class="el-dropdown-link">
                  <span @click="onPage2('/member')">会员中心</span>
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menuTwo">
                  <el-dropdown-item @click.native="onPage2('/member/news')">会员动态</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/member/intro')">会员简介</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/member/certificate')">会员证书</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
            <el-menu-item index="/list/6/关于协会" class="full-width-item">
              <el-dropdown placement ="bottom">
                <span class="el-dropdown-link">
                  <span  @click="onPage2('/list/6/关于协会')">关于协会</span> 
                  <!-- <img src="./assets/img/newHome/downIcon.png" style="margin-left: 5px;" /> -->
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menuTwo">
                  <el-dropdown-item @click.native="onPage2('/detail/6-1')">协会简介</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-2')">协会章程</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-10')">会费标准</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-3')">业务范围</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-9')">协会架构</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-4')">协会领导</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-7')">监事单位</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-8')">理事单位</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-5')">会员名单</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/6-6')">联系我们</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>

            <el-menu-item index="/list/10/加入协会" class="full-width-item">
              <el-dropdown placement ="bottom"   >
                <span class="el-dropdown-link">
                  <span @click="onPage2('/list/10/加入协会')">加入协会</span> 
                  <!-- <img src="./assets/img/newHome/downIcon.png" style="margin-left: 5px;" /> -->
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menuTwo">
                  <el-dropdown-item @click.native="onPage2('/detail/10-1')">协会服务</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/10-2')">会员义务</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/10-3')">入会流程</el-dropdown-item>
                  <el-dropdown-item @click.native="onPage2('/detail/10-4')">申请表格</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
        </el-menu>
      </div>

        <!-- <div class="visitorNumber">
          <div class="text" >累计访客：{{pageView.pageViewTotal}} 人   /   今日访客：{{ pageView.pageViewToday }} 人</div>
     
        </div> -->
      </div>
    </el-header>
    <router-view />
    <el-footer  style="padding: 0;" v-if="$route.meta.keepAlive" >
      <div style="height: 40px;background: #018745;display: flex;align-items: center;justify-content: space-between;padding: 5px;">
        <div style="font-weight: 700;color: #FFFFFF;padding-left: 24px;margin-left: 10%;  ">{{year}}年{{month}}月{{day}}日 | {{currentWeekDay}} |农历.{{ lunarYear }}年 | {{ lunarMonth }}月{{ lunarDay }}</div>
        <div style=" font-weight: 700; font-size: 16px; margin-right: 10%; color: #FFFFFF; padding: 5px 24px;font-style: normal; text-transform: none;  font-family: Microsoft YaHei, Microsoft YaHei;" >
          累计访客：{{pageView.pageViewTotal}} 人   /   今日访客：{{ pageView.pageViewToday }} 人</div>
      </div>
      <div class="footerBox">
        <div class="footerBoxTop">
          <img src="./assets/img/newHome/bottomLogo.png" style="width:320px; "/>
          <img src="./assets/img/newHome/bottomSlogan.png" style="width:280px;" />
        </div>
        <div style="height: 2px;background: #018745;">
            
        </div>

        <div class="footerBoxBottom">
          <div class="footerLayout">
              <div class="title">联系我们</div>

              <div class="messageBox" style="margin-top: 10px;">
                <img src="./assets/img/newHome/icon-Address.png" style="margin-right:16px;width: 20px;" />
                <span class="text">沈阳市皇姑区崇山东路71号</span>
              </div>
              <div class="messageBox">
                <img src="./assets/img/newHome/icon-Tel.png" style="margin-right: 16px;width: 20px;" />
                <span class="text">024-31509715</span>
              </div>
              <div class="messageBox">
                <img src="./assets/img/newHome/icon-Copyright.png" style="margin-right:16px;width: 20px;" />
                <span class="text">辽宁省政府采购协会</span>
              </div>
              <div class="messageBox">
                <img src="./assets/img/newHome/icon-ArchivalInfo.png" style="margin-right: 16px;width: 20px;" />
                <span class="text">辽ICP备20009704号-1</span>
              </div>
          </div>
          <div class="footerLayout">
            <div class="title">友情链接</div>
            <div class="messageBox" style="margin-top: 10px;">
              <a class="link" @click="handleChinaZhengTingEvent">• 中国政府采购网</a>
            </div>
            <div class="messageBox" >
              <a class="link" @click="handleCaiZhengTingEvent">• 辽宁省财政厅</a>
            </div>
            <div class="messageBox" >
              <a class="link" @click="handleCaiGouWangEvent">• 辽宁政府采购网</a>
            </div>
            <div class="messageBox">
              <a class="link" @click="handleFuWuPingTaiEvent">• 辽宁政府购买服务信息平台</a>
            </div>
            
          </div>
          <div class="footerLayoutTwo">
            <div class="title">关注我们</div>

            <img src="./assets/img/newHome/official.png" style="margin-top: 10px;width: 100px;" />
            <div style="width: 100px;font-size: 16px;color: #FFFFFF;text-align: center;margin-top: 2px;">微信公众平台</div>
          </div>
        </div>
      </div>
    </el-footer>

  </div>
</template>

<script>
import { prefixedUrlAsset } from '@/utils/constants';
import { getLunar } from 'chinese-lunar-calendar';
export default {
  name: 'App',
  data() {
    return {
      top_show: true,
      childrenId: "",
      menus: [
        {
          id: 0,
          name: '首页',
          select: true,
        },
        {
          id: 1,
          name: '协会动态',
          select: false,
        },
        {
          id: 2,
          name: '通知公告',
          select: false,
        },
        {
          id: 3,
          name: '行业资讯',
          select: false,
        },
        {
          id: 4,
          name: '政策法规',
          select: false,
          children: [
            {
              name: "国家规范性文件",
              id: "1"
            },
            {
              name: "地方规范性文件",
              id: "2"
            }
          ]
        },
        {
          id: 7,
          name: '党建园地',
          select: false,
        },
        {
          id: 5,
          name: '诚信自律',
          select: false,
        },
        {
          id: 6,
          name: '关于协会',
          select: false,
          children: [
            {
              name: "协会简介",
              id: "6-1"
            },
            {
              name: "协会章程",
              id: "6-2"
            },
            {
              name: "业务范围",
              id: "6-3"
            },
            {
              name: "协会架构",
              id: "6-9"
            },
            {
              name: "协会领导",
              id: "6-4"
            },
            {
              name: "监事单位",
              id: "6-7"
            },
            {
              name: "理事单位",
              id: "6-8"
            },
            {
              name: "会员名单",
              id: "6-5"
            },
            {
              name: "联系我们",
              id: "6-6"
            },

          ]
        },
        {
          id: 10,
          name: '加入协会',
          select: false,
          children: [
            {
              name: "协会服务",
              id: "10-1"
            },
            {
              name: "会员义务",
              id: "10-2"
            },
            {
              name: "入会流程",
              id: "10-3"
            },
            {
              name: "申请表格",
              id: "10-4"
            }
          ]
        }
      ],
      height: 0,
      menuChildren: {},
      x: 0,
      y: 0,
      ul_width: 0,
      menuDropdown: false,
      activeIndex: '1',
      isDropdownClicked: false,
      year:'',
      month:'',
      day:'',
      currentWeekDay:'',
      pageView: { pageViewTotal: 0, pageViewToday: 0 },
      lunarDate: '',
      menuItems: [
        { path: '/', name: '首页', index: '/' },
        { path: '/list/1/协会动态', name: '协会动态', index: '/list/1/协会动态' },
        { path: '/list/2/通知公告', name: '通知公告', index: '/list/2/通知公告' },
        { path: '/list/3/行业资讯', name: '行业资讯', index: '/list/3/行业资讯' },
        { path: '/list/4/国家规范性文件', name: '国家规范性文件', index: '/list/4/政策法规' },
        { path: '/list/4/地方规范性文件', name: '地方规范性文件', index: '/list/4/政策法规' },
        { path: '/list/4/政策法规', name: '政策法规', index: '/list/4/政策法规' },
        { path: '/list/7/党建园地', name: '党建园地', index: '/list/7/党建园地' },
        { path: '/list/5/诚信自律', name: '诚信自律', index: '/list/5/诚信自律' },
        { path: '/list/6/关于协会', name: '关于协会', index: '/list/6/关于协会' },
        { path: '/detail/6-1', name: '协会简介', index: '/list/6/关于协会' },
        { path: '/detail/6-2', name: '协会章程', index: '/list/6/关于协会' },
        { path: '/detail/6-3', name: '协会简介', index: '/list/6/关于协会' },
        { path: '/detail/6-9', name: '协会架构', index: '/list/6/关于协会' },
        { path: '/detail/6-4', name: '协会领导', index: '/list/6/关于协会' },
        { path: '/detail/6-7', name: '监事单位', index: '/list/6/关于协会' },
        { path: '/detail/6-8', name: '理事单位', index: '/list/6/关于协会' },
        { path: '/detail/6-5', name: '会员名单', index: '/list/6/关于协会' },
        { path: '/detail/6-6', name: '联系我们', index: '/list/6/关于协会' },
        { path: '/detail/6-10', name: '会费标准', index: '/list/6/关于协会' },

        { path: '/detail/10-1', name: '协会服务', index: '/list/10/加入协会' },
        { path: '/detail/10-2', name: '会员义务', index: '/list/10/加入协会' },
        { path: '/detail/10-3', name: '入会流程', index: '/list/10/加入协会' },
        { path: '/detail/10-4', name: '申请表格', index: '/list/10/加入协会' },
      ],
      lunarYear: '',
      lunarMonth: '',
      lunarDay: '',
      input: ''
    };
  },
  watch: {
    $route(to) {
      console.log("to",to.path)
      this.setActiveMenu(to.path);
     
    },
  },
  created() {
    this.setActiveMenu(this.$route.path);
  },
  mounted() {
    this.getPageView()
    this.getData()
    this.getLunarDate();
  },
  methods: {
    getLunarDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始，需要加1
      const day = date.getDate();
 
      const lunarDate = getLunar(year, month, day);
 
      this.lunarYear = lunarDate.lunarYear + '（' + lunarDate.zodiac + '）';
      this.lunarMonth = this.numberToChineseDigits(lunarDate.lunarMonth) ;
      this.lunarDay = lunarDate.lunarDate < 10 ? "初"+this.numberToChineseDigits(lunarDate.lunarDate)   : this.numberToChineseDigits(lunarDate.lunarDate)  ;
    },
    numberToChineseDigits(num) {
      const digitMap = {
          '0': '零',
          '1': '一',
          '2': '二',
          '3': '三',
          '4': '四',
          '5': '五',
          '6': '六',
          '7': '七',
          '8': '八',
          '9': '九'
      };
      // 将数字转换为字符串，以便逐个字符处理
      const numStr = num.toString();
      // 如果数字是0，直接返回“零”
      if (numStr === '0') {
          return digitMap['0'];
      }
      // 如果数字是两位数，则分别转换十位和个位
      if (numStr.length === 2) {
          const tenDigit = numStr[0];
          const oneDigit = numStr[1];
          // 特殊处理10-19之间的数字，因为中文里“十”前面不加“一”
          if (tenDigit === '1') {
              return '十' + (oneDigit === '0' ? '' : digitMap[oneDigit]);
          } else {
              return digitMap[tenDigit] + '十' + (oneDigit === '0' ? '' : digitMap[oneDigit]);
          }
      }
      // 如果数字是个位数，直接转换
      return digitMap[numStr];
    },
    setActiveMenu(path) {
      console.log(6666,path)
      const matchingItem = this.menuItems.find(item => item.path === path);
      if (matchingItem) {
        this.activeIndex = matchingItem.index;
      }
    },
    onPage2(path) {
      console.log('path',path)
      this.$router.push(path);
    },
    handleSelect(index, indexPath){
      console.log('yu',index, indexPath)

      switch (index) {
        case 1 : 
        this.$router.push('/list/1/协会动态');    
          break;
        case 1 : 
          this.$router.replace('/');        
          break;     
            
      }
    },
    getData(){
      const currentDate = new Date();
      this.year = currentDate.getFullYear();
      this.month = currentDate.getMonth() + 1; // 月份从0开始，所以需要加1
      this.day = currentDate.getDate();
      const weekDay = currentDate.getDay(); // 0代表星期日，1代表星期一，以此类推
      
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.currentWeekDay = weekDays[weekDay];
    },
    getPageView() {
      this.axios.get(`${prefixedUrlAsset}/api/auth/pageView`).then((({ data })=> {
        // 后端在 Redis 不可用等异常下可能只返回 {code, msg} 而无 data
        if (data && data.code === 0 && data.data) {
          this.pageView = data.data;
        } else {
          this.pageView = { pageViewTotal: 0, pageViewToday: 0 };
        }
      })).catch(() => {
        this.pageView = { pageViewTotal: 0, pageViewToday: 0 };
      });
    },
    handleMenuEvent(event, index, name, id) {


      // eslint-disable-next-line array-callback-return
      this.menus.map((item, itemIndex) => {
        if (itemIndex === index) {
          this.$set(item, 'select', true);
        } else {
          this.$set(item, 'select', false);
        }
      });

      if (index === 0) {
        this.$router.replace('/');
      } else {
        this.$router.push(`/list/${id}/${name}`);
      }
    },
    handleChinaZhengTingEvent() {
      window.open('https://www.ccgp.gov.cn');
    },
    handleCaiZhengTingEvent() {
      window.open('http://czt.ln.gov.cn');
    },
    handleCaiGouWangEvent() {
      window.open('http://www.ccgp-liaoning.gov.cn');
    },
    handleFuWuPingTaiEvent() {
      window.open('http://218.60.145.55/login.do?method=beginlogin&redirectURL=login.do!!@@method@@governmentBuy');
    },
    searchData(){
      const  {href}  = this.$router.resolve({
        path:`/searchList`,
        query: {keywords:this.input,}
                
      });
      window.open(href, '_blank');
    },
  }
};
</script>

<style lang="less">
    .homeHeader {
      width: 100%;
      background-color: #FFFFFF;
      .headerTop{
        display: flex;
        align-items: center;
        padding: 0px 10%;
        background: #d3e8d5;
        height: 144px;
        .searchContent{
          height: 48px;
          background: #FFFFFF;
          border-radius: 28px 28px 28px 28px;
          border: 1px solid #d3e8d5;
          display: flex;
          align-items: center;
          .el-input__inner {
            border: 0px solid #DCDFE6;
          }
          .searchButton{
            width: 120px;
            background: #84d26f;
            border-radius: 0px 28px 28px 0px;
            border: 1px solid #d3e8d5;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .el-icon-search{
              font-size: 24px;
              color: #fff;
            }
          }

        }
      }
    }
    .menuBox{
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #018745;
      padding: 0px 10% ;
      .full-width-item {
        flex: 1; 
        text-align: center;
    }
      .el-menu--horizontal>.el-menu-item.is-active{
          border-bottom: 0px solid #018745;
          font-weight: 400;
          background: #d3e8d5;
          color: #000000;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-style: normal;
          text-transform: none;
          .el-dropdown-link {
            color: #000000;
          }
      }
      .el-menu--horizontal>.el-menu-item {
          font-weight: bold ;
          font-size: 16px;
          color: #FFFFFF;
          font-weight: 400;
          font-family: Microsoft YaHei, Microsoft YaHei;
      }
      .el-menu--horizontal>.el-submenu .el-submenu__title {
        font-weight: bold ;
        font-size: 16px;
        color: #000000 ;
      }
      .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
        outline: 0;
        background-color: #FFFFFF;
        color: #018745 !important;
        .el-dropdown-link {
          color: #018745 !important;
          span {
            color: #018745 !important;
          }
        }
      }
      .el-menu.el-menu--horizontal {
        background: #018745;
      }
      .el-dropdown {
          //color: #000000;
          font-size: 16px;
          margin-top: -6px;
      }
      .el-dropdown-link {
          color: #FFFFFF !important;
          cursor: pointer;
          span {
            color: #FFFFFF !important;
          }
          &:hover {
            color: #018745 !important;
            span {
              color: #018745 !important;
            }
          }
      }
      .el-menu--horizontal > .el-submenu .el-submenu__title {
          font-size: 16px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          font-style: normal;
          text-transform: none;
      }
      .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
          display: none;
      }
      .visitorNumber{
        height: 30px;
        background: rgba(0, 162, 135, 0.2);
        border-radius: 16px 16px 16px 16px;
        margin-right: 150px;
        .text{
          font-size: 14px;
          color: #000000;
          padding: 5px 24px;
          font-style: normal;
          text-transform: none;
          font-family: Microsoft YaHei, Microsoft YaHei;
        }
      }
     
    }
    .custom-dropdown-menu {
      display: block; /* 确保它是块级元素 */
      width: 138px; /* 或者你想要的任何宽度 */
      .el-dropdown-item {
        display: block; /* 确保每个下拉项也是块级元素 */
        width: 100%;
      }
      .el-dropdown-item:focus, .el-dropdown-item:not(.is-disabled):hover {
          background-color: #def4e8;
          color: #018745;
      }
    }
    .custom-dropdown-menuTwo{
      display: block; /* 确保它是块级元素 */
      width: 96px; /* 或者你想要的任何宽度 */
      .el-dropdown-item {
        display: block; /* 确保每个下拉项也是块级元素 */
        width: 100%;
      }
      .el-dropdown-item:focus, .el-dropdown-item:not(.is-disabled):hover {
          background-color: #def4e8;
          color: #018745;
      }
    }
    .selectColor{
      color:#018745;
      font-weight: 0;
    }
    .defaultColor{
      color: #000000;
    }
    .el-dropdown-link{
      color: #000000;
      &:hover {
        color: #018745
      }
    }

    .footerBox{
     background: #374049;;
      padding: 0 10%;
      .footerBoxTop{
        padding: 10px 17% 10px 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .footerBoxBottom{
        padding: 10px 40px 10px 20px;
        display: flex;
        .footerLayout{
          // flex: 1;
          width: 45%;
          margin-left: 110px;
          .title{
            font-weight: bold;
            font-size: 20px;
            color: #018745;
            line-height: 20px;
            text-align: left;
          }
          .messageBox{
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            .text{
              font-size: 14px;
              color: #FFFFFF;
            }
            .link{
              cursor: pointer;
              font-size: 14px;
              color: #FFFFFF;
              &:hover {
                color: #36D8BD;
                font-weight: 700;
              }
            }
          }
        }
        .footerLayoutTwo{
          width: 20%;
          margin-left: 10%;
          .title{
            font-weight: bold;
            font-size: 20px;
            color: #018745;
            line-height: 20px;
            text-align: left;
          }
        }
      }
    }
    .footerTrabecula{
      background: #006E5C;
      height: 40px;
     
    }
 
</style>

<style lang="scss">
#app {
  max-width: 1440px;
  margin: 0 auto
}
.homeHeader {
  &__top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 150px;
    background-color: white;
    .header-bg {
      position: absolute;
      width: 70%;
      height: 150px;
    }
    .left-header {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding-top: 20px;
      padding-left: 20px;
      .header-icon {
        width: 70px;
        height: 70px;
        background-color: white;
      }
      .header-title {
        margin-left: 10px;
        line-height: 70px;
        font-size: 35px;
        font-weight: bold;
        color: #006d32;
        background-color: white;
      }
    }
    .slogan-header {
      margin-top: 40px;
      margin-right: 40px;
      width: 200px;
    }
  }
  &__bottom {
    width: 100%;
    height: 50px;
    cursor: pointer;
    background-color: white;
  }
}
.bg-purple-dark {
  background: #99a9bf;
}

.footer-bottom {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 300px;
  background-color: #364048;
  &__icon {
    width: 80px;
    height: 80px;
    padding: 50px 10px 0px 50px;
  }
  &__card {
    height: 70px;
    padding: 50px 0px 0px 0px;
    &__ch {
      font-size: 30px;
      color: white;
      font-weight: bold;
    }
    &__en {
       font-size: 15px;
       color: white;
       padding-bottom: 30px;
     }
    &__info {
      font-size: 13px;
      color: white;
      margin-top: 10px;
    }
  }
}

</style>
